import './widgetSmal.css';

import React from 'react';
import { Visibility } from '@mui/icons-material';
export default function widgetSmal() {
  return (
    <div className="sm">
      <span className="smTitle">New join Members</span>
      <ul className="smList">
        <li className="smListItem">
          <img
            src="https://images.pexels.com/photos/1382734/pexels-photo-1382734.jpeg?auto=compress&cs=tinysrgb&w=600"
            alt=""
            className="smImg"
          />
          <div className="smUser">
            <span className="smName">Anan kellar</span>
            <spam className="smJob">Softare Engineering</spam>
          </div>
          <button className="smbtn">
            <Visibility className="smVis"></Visibility>
            Display
          </button>
        </li>
        <li className="smListItem">
          <img
            src="https://images.pexels.com/photos/1382734/pexels-photo-1382734.jpeg?auto=compress&cs=tinysrgb&w=600"
            alt=""
            className="smImg"
          />
          <div className="smUser">
            <span className="smName">Anan kellar</span>
            <spam className="smJob">Softare Engineering</spam>
          </div>
          <button className="smbtn">
            <Visibility className="smVis"></Visibility>
            Display
          </button>
        </li>
        <li className="smListItem">
          <img
            src="https://images.pexels.com/photos/1382734/pexels-photo-1382734.jpeg?auto=compress&cs=tinysrgb&w=600"
            alt=""
            className="smImg"
          />
          <div className="smUser">
            <span className="smName">Anan kellar</span>
            <spam className="smJob">Softare Engineering</spam>
          </div>
          <button className="smbtn">
            <Visibility className="smVis"></Visibility>
            Display
          </button>
        </li>
        <li className="smListItem">
          <img
            src="https://images.pexels.com/photos/1382734/pexels-photo-1382734.jpeg?auto=compress&cs=tinysrgb&w=600"
            alt=""
            className="smImg"
          />
          <div className="smUser">
            <span className="smName">Anan kellar</span>
            <spam className="smJob">Softare Engineering</spam>
          </div>
          <button className="smbtn">
            <Visibility className="smVis"></Visibility>
            Display
          </button>
        </li>
        <li className="smListItem">
          <img
            src="https://images.pexels.com/photos/1382734/pexels-photo-1382734.jpeg?auto=compress&cs=tinysrgb&w=600"
            alt=""
            className="smImg"
          />
          <div className="smUser">
            <span className="smName">Anan kellar</span>
            <spam className="smJob">Softare Engineering</spam>
          </div>
          <button className="smbtn">
            <Visibility className="smVis"></Visibility>
            Display
          </button>
        </li>
        <li className="smListItem">
          <img
            src="https://images.pexels.com/photos/1382734/pexels-photo-1382734.jpeg?auto=compress&cs=tinysrgb&w=600"
            alt=""
            className="smImg"
          />
          <div className="smUser">
            <span className="smName">Anan kellar</span>
            <spam className="smJob">Softare Engineering</spam>
          </div>
          <button className="smbtn">
            <Visibility className="smVis"></Visibility>
            Display
          </button>
        </li>
      </ul>
    </div>
  );
}
